<script>

import Papa from 'papaparse'
import employeeJSON from '@/employees.json'

var employeeList = []
export default {
  props: {
    value: String,
  },
  components: {
  },
  data() {
    return {
      adminPass: '',
      isManager: false,
      weeklyGoal: 0,
      searchName: ''
    }
  },
  methods: {
    managerPassword(){
        if(this.adminPass === 'admin123'){
            this.isManager = true
            this.adminPass = ''
        }
    }
  },
  created(){
    this.employeeList = employeeJSON
  }
}
</script>

<template>
    <div v-if="!isManager" class="login">
        <p>Enter Manager Password</p>
        <input v-model="adminPass" @keyup.enter="managerPassword" placeholder="Enter Password" /> <br />
        <!-- type="password" -->
    </div>
    <div v-if="this.isManager" class="managerFunctions">
        <h1>Enter Weekly Goal</h1>
        <input v-model="weeklyGoal" @keyup.enter="weeklyGoal" placeholder="Enter Weekly Goal"  /> <br />

        <div class="store">
          <h2>Select Store</h2>
          <div class="options">
            <label><input type="radio" name="store" value="soho"> Soho</label>
            <label><input type="radio" name="store" value="ues"> UES</label>
            <label><input type="radio" name="store" value="gt"> GT</label>
          </div>
          Search Name <input type="text" v-model="searchName" placeholder="Employee Name">
          <div v-for="employee in employeeList" class="employees">            
            <div v-if="employee.name.toLowerCase().includes(this.searchName.toLowerCase())">
              {{ employee.name }}
              <div class="hours">
                Week 1: <input type="text" size="2"> Hours <br>
                Week 2: <input type="text" size="2"> Hours <br>
                Week 3: <input type="text" size="2"> Hours <br>
                Week 4: <input type="text" size="2"> Hours <br>
                Total Hours: {{ employee.totalHours }}
                <hr>
              </div>
              
            </div>
          
          </div>
        </div>
    </div>
   
</template>

<style lang="scss" scoped>

</style>
